module.exports = __webpack_public_path__ + "images/06e6b520.png";